import React, { useState, useEffect } from 'react';
import PageLoader from '../../components/Common/PageLoader';
import { BookMarked, LayoutDashboard, Target, ShieldCheck } from 'lucide-react';
import KeyMetrics from './components/KeyMetrics';
import IncidentTrends from './components/IncidentTrends';
import ResponseTimeAnalysis from './components/ResponseTimeAnalysis';
import TopThreatSources from './components/TopThreatSources';
import ReportTemplates from './components/ReportTemplates';
import MitreCoverage from './components/MitreCoverage';
import MitreTechniquesTable from './components/MitreTechniquesTable';
import SecurityPostureScore from './components/SecurityPostureScore';
import ReportPreviewModal from './components/ReportPreviewModal';
import ReportLibrary from './components/ReportLibrary';
import './reports.scss';

const TABS = [
  { id: 'library',   label: 'Reports Library', icon: BookMarked      },
  { id: 'dashboard', label: 'Dashboard',        icon: LayoutDashboard },
  { id: 'mitre',     label: 'MITRE Assessment', icon: Target          },
  { id: 'posture',   label: 'Security Posture', icon: ShieldCheck     },
];

export default function Reports() {
  const [tab, setTab]                     = useState('library');
  const [loading, setLoading]             = useState(true);
  const [previewReport, setPreviewReport] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 700);
    return () => clearTimeout(t);
  }, []);

  if (loading) return <PageLoader loading />;

  return (
    <div className="reports">
      {previewReport && (
        <ReportPreviewModal reportType={previewReport} onClose={() => setPreviewReport(null)} />
      )}

      {/* Header */}
      <div className="reports__header">
        <div>
          <h1 className="reports__title">Security Reports</h1>
          <p className="reports__subtitle">Azure Sentinel-backed reports · MITRE ATT&amp;CK analytics · per-client library</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="reports__tabs">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`reports__tab${tab === id ? ' reports__tab--active' : ''}`}
            onClick={() => setTab(id)}
          >
            <Icon size={15} />
            {label}
          </button>
        ))}
      </div>

      {/* ── Reports Library ── */}
      {tab === 'library' && <ReportLibrary />}

      {/* ── Dashboard ── */}
      {tab === 'dashboard' && (
        <>
          <KeyMetrics />
          <div className="reports__charts">
            <IncidentTrends />
            <ResponseTimeAnalysis />
          </div>
          <MitreCoverage />
          <TopThreatSources />
          <ReportTemplates onPreview={setPreviewReport} />
        </>
      )}

      {/* ── MITRE Assessment ── */}
      {tab === 'mitre' && (
        <>
          <MitreCoverage />
          <MitreTechniquesTable />
          <ReportTemplates onPreview={setPreviewReport} filter="mitre" />
        </>
      )}

      {/* ── Security Posture ── */}
      {tab === 'posture' && (
        <>
          <SecurityPostureScore />
          <MitreTechniquesTable />
          <ReportTemplates onPreview={setPreviewReport} filter="posture" />
        </>
      )}
    </div>
  );
}
